import { JSX } from 'react';
import { useGetFieldDisplay } from '../../hooks/lockedFeatures/useFieldDisplay';
import { useGetTabDisplay } from '../../hooks/lockedFeatures/useTabDisplay';
import { FeatureLock } from '../../../common/LockedFeatures';

export const SettingsFeatureLock = (props: {
    id: string;
    children: JSX.Element;
    isTabId?: boolean;
    className?: string;
}) => {
    const { id, children, isTabId = false, className = '' } = props;
    const fieldDisplay = useGetFieldDisplay(id);
    const tabDisplay = useGetTabDisplay(id);
    return (
        <FeatureLock displayOptions={isTabId ? tabDisplay : fieldDisplay} className={className}>
            {children}
        </FeatureLock>
    );
};
